import { getUUID } from '../id-utils/id.utils';

/**
 * Data structure to hold objects in a set
 * Any two objects that are identical (but not the same object) cannot both be added
 * Added objects must be considered immutable while they are in the set
 */
export class ObjectSet<T> {
	private map: Map<string, T> = new Map();
	private getSeed: (t: T) => string;

	get size(): number {
		return this.map.size;
	}

	get entries(): T[] {
		return Array.from(this.map.values());
	}

	constructor(seedFunction: (t: T) => string, initialContents: T[] = []) {
		// Store seed function for later use
		this.getSeed = (t: T) => getUUID(seedFunction(t));

		// Insert initial items
		initialContents.forEach(item => this.add(item));
	}

	add(object: T): ObjectSet<T> {
		this.map.set(this.getSeed(object), object);
		return this;
	}

	clear(): void {
		this.map.clear();
	}

	delete(object: T): boolean {
		const exists = this.has(object);
		this.map.delete(this.getSeed(object));
		return exists;
	}

	forEach(callback: (entry: T) => any): void {
		for (const entry of this.entries) {
			callback(entry);
		}
	}

	has(object: T): boolean {
		return this.map.has(this.getSeed(object));
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
